<template>
  <div class="aboutus">
    <Header></Header>
    <div class="aboutus-banner flex-col">
      <div class="container">
        <p>行业首创“一对一”服务模式</p>
        <p>打通项目落地最后一公里</p>
      </div>
    </div>
    <div id="introduce" class="aboutus-intro">
      <div class="container">
        <p class="aboutus-title">公司简介</p>
        <p
          class="wow animate__animated animate__fadeInUp"
          data-wow-delay=".1s"
          data-wow-offset="10"
        >
          中产集团是国内三十多家上市公司实控人共同发起，聚焦于产业投资、产业赋能，已成功投资容百科技、国轩高科、通威股份、云从科技、中节能太阳能等24家产业龙头企业上市，总部上海星动力位于上海世博园核心地带，占地一万多平米，打造了全国领先的高端企业家线下交流平台和产业投资平台，建立了全国领先的产业大数据系统，每年聚集1000多个产业项目，和全国各地政府、园区建立起友好合作关系。中产集团已签约中信建投、国浩律所、立信会所，成为行业首家拟上市公司。
        </p>
        <p
          class="wow animate__animated animate__fadeInUp"
          data-wow-delay=".2s"
          data-wow-offset="10"
        >
          集团现有员工700余人，在北京、深圳设有分支机构，在美国、英国、德国、日本设有办事处，深度整合京津冀、长三角、粤港澳及海外优质项目资源，近年来已赋能大量的百亿、数十亿投资体量的产业项目成功落地。2014及2015年，中产集团创始人朱阳先生连续两年作为国内基金业行业代表陪同习近平总书记、时任李克强总理多次出访欧洲，且在时任李克强总理见证下在英国伦敦成立国内首家专注于海外中小企业成长的专项基金。
        </p>
        <p
          class="wow animate__animated animate__fadeInUp"
          data-wow-delay=".3s"
          data-wow-offset="10"
        >
          集团旗下上海星动力科创空间坐落于上海世博轴，秉承“演绎永不落幕的世博会”理念，聚集要素资源，携手投资机构、龙头企业、各类产业联盟、高校以及产融服务组织，已成为一个集聚前沿科技资讯、金融资本、科技项目、创新人才、龙头企业、交流活动等创新要素的超级服务平台，并正在成为新型产业连接、合作的超级平台。
        </p>
        <p
          class="wow animate__animated animate__fadeInUp bold"
          data-wow-delay=".4s"
          data-wow-offset="10"
        >
          使命：以产业平台为发动机助推产业发展
        </p>
        <p
          class="wow animate__animated animate__fadeInUp bold"
          data-wow-delay=".5s"
          data-wow-offset="10"
        >
          愿景：成为全球领先的产业资源运营及企业赋能平台
        </p>
        <p
          class="wow animate__animated animate__fadeInUp bold"
          data-wow-delay=".6s"
          data-wow-offset="10"
        >
          价值观：快乐事业 高效协作 成就客户 追求卓越
        </p>
      </div>
    </div>
    <div id="creator" class="aboutus-create">
      <div class="container">
        <p class="aboutus-title" style="padding:60px 0 50px">创始人寄语</p>
        <div class="flex-row">
          <div>
            <img width="450" src="@/assets/images/aboutUs/creator.jpg" alt="" />
            <div class="creator-intro flex-row">
              <div class="intro-left">
                <p style="margin-top:-5px">中产集团创始人、董事长</p>
                <!-- <p style="margin-bottom:-5px">欧擎集团、TSF通盛时富创始人</p> -->
              </div>
              <div class="intro-right">朱阳</div>
            </div>
          </div>
          <div class="creator-right flex-col">
            <p
              class="wow animate__animated animate__fadeInRight"
              data-wow-offset="10"
              data-wow-delay=".1s"
            >
              总有一种使命承载着变革的方向，让我们无法卸肩；总有一种机遇，如潮而至，我们唯有全力奔赴。
            </p>
            <p
              class="wow animate__animated animate__fadeInRight"
              data-wow-offset="10"
              data-wow-delay=".2s"
            >
              产业升级——这是改革开放四十年的语境下中国经济衍生的新命题。
            </p>
            <p
              class="wow animate__animated animate__fadeInRight"
              data-wow-offset="10"
              data-wow-delay=".3s"
            >
              从经济特区到“一带一路”，从工业化到城镇化，从全球化到逆全球化，我们见证了物质匮乏年代的创富奇迹，见证了出口加工制造让中国成为“世界工厂”，见证了“BAT时代”弯道超车的互联网冲刺，见证了国际竞争新格局下产业的转型与突围。
            </p>
            <p
              class="wow animate__animated animate__fadeInRight"
              data-wow-offset="10"
              data-wow-delay=".4s"
            >
              企业创新、科技变革、产业转型……这个时代的价值要素，以前所未有的活力和充盈，也以前所未有的颠覆和重构，释放着激荡的脉搏。
            </p>
            <p
              class="wow animate__animated animate__fadeInRight"
              data-wow-offset="10"
              data-wow-delay=".5s"
            >
              站在创新与变革的风口，中产集团以服务创新企业和区域产业发展为担当，全力构筑数智化产业招商服务平台，致力成为最富创新影响力的产业发展集成服务商。
            </p>
            <p
              class="wow animate__animated animate__fadeInRight"
              data-wow-offset="10"
              data-wow-delay=".6s"
            >
              中产集团应“新时代”而来，也将以“新成果”而长。我们坚信，它也将在区域产业发展的创造性实践中兑现自己的价值。
            </p>
          </div>
          <img class="mark" src="@/assets/images/aboutUs/mark.png" alt="" />
        </div>
      </div>
    </div>
    <div id="organization" class="aboutus-org">
      <div class="container">
        <p class="aboutus-title" style="padding:60px 0">组织架构</p>
        <svg
          class="wow animate__animated animate__fadeIn"
          data-wow-offset="10"
          data-wow-delay=".1s"
          width="1182px"
          height="757px"
          viewBox="0 0 1182 757"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <title>编组 14</title>
          <defs>
            <linearGradient
              x1="100%"
              y1="50%"
              x2="0%"
              y2="50%"
              id="linearGradient-1"
            >
              <stop stop-color="#2F9ECD" offset="0%"></stop>
              <stop stop-color="#15659E" offset="100%"></stop>
            </linearGradient>
            <linearGradient
              x1="0%"
              y1="50%"
              x2="100%"
              y2="50%"
              id="linearGradient-2"
            >
              <stop stop-color="#15659E" offset="0%"></stop>
              <stop stop-color="#2F9ECD" offset="100%"></stop>
            </linearGradient>
            <rect
              id="path-3"
              x="441"
              y="149"
              width="300"
              height="70"
              rx="4"
            ></rect>
            <filter
              x="-11.7%"
              y="-35.7%"
              width="123.3%"
              height="200.0%"
              filterUnits="objectBoundingBox"
              id="filter-4"
            >
              <feOffset
                dx="0"
                dy="10"
                in="SourceAlpha"
                result="shadowOffsetOuter1"
              ></feOffset>
              <feGaussianBlur
                stdDeviation="10"
                in="shadowOffsetOuter1"
                result="shadowBlurOuter1"
              ></feGaussianBlur>
              <feColorMatrix
                values="0 0 0 0 0.0823529412   0 0 0 0 0.396078431   0 0 0 0 0.619607843  0 0 0 0.2 0"
                type="matrix"
                in="shadowBlurOuter1"
              ></feColorMatrix>
            </filter>
          </defs>
          <g
            id="页面-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="关于我们-公司介绍"
              transform="translate(-368.000000, -2626.000000)"
            >
              <g id="1备份-5" transform="translate(-0.227053, 2450.000000)">
                <g id="编组-14" transform="translate(369.000000, 176.000000)">
                  <path
                    d="M223,185 L1003,185 L223,185 Z"
                    id="路径-2"
                    stroke-opacity="0.5"
                    stroke="#15659E"
                    stroke-width="2"
                  ></path>
                  <path
                    d="M30,321 L30,275 C30,271.686292 32.6862915,269 36,269 L1144,269 C1147.31371,269 1150,271.686292 1150,275 L1150,320.640316 L1150,320.640316"
                    id="路径-2"
                    stroke-opacity="0.5"
                    stroke="#15659E"
                    stroke-width="2"
                  ></path>
                  <path
                    d="M236,602 L236,556 C236,552.686292 238.686292,550 242,550 L932,550 C935.313708,550 938,552.686292 938,556 L938,601.640316 L938,601.640316"
                    id="路径-2"
                    stroke-opacity="0.5"
                    stroke="#15659E"
                    stroke-width="2"
                  ></path>
                  <line
                    x1="591.227053"
                    y1="100"
                    x2="591.227053"
                    y2="150"
                    id="路径-3"
                    stroke-opacity="0.5"
                    stroke="#15659E"
                    stroke-width="2"
                  ></line>
                  <line
                    x1="591.227053"
                    y1="219"
                    x2="591.227053"
                    y2="269"
                    id="路径-3"
                    stroke-opacity="0.5"
                    stroke="#15659E"
                    stroke-width="2"
                  ></line>
                  <line
                    x1="591.227053"
                    y1="499"
                    x2="591.227053"
                    y2="549"
                    id="路径-3"
                    stroke-opacity="0.5"
                    stroke="#15659E"
                    stroke-width="2"
                  ></line>
                  <g id="编组-11" transform="translate(51.000000, 156.000000)">
                    <rect
                      id="矩形"
                      fill="#278CBE"
                      x="0"
                      y="0"
                      width="220"
                      height="60"
                      rx="4"
                    ></rect>
                    <text
                      id="总裁办"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="22"
                      font-weight="500"
                      fill="#FFFFFF"
                    >
                      <tspan x="77" y="38">总裁办</tspan>
                    </text>
                  </g>
                  <g id="编组-10" transform="translate(901.000000, 156.000000)">
                    <rect
                      id="矩形备份-5"
                      fill="#278CBE"
                      x="0"
                      y="0"
                      width="220"
                      height="60"
                      rx="4"
                    ></rect>
                    <text
                      id="董事会办公室"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="22"
                      font-weight="500"
                      fill="#FFFFFF"
                    >
                      <tspan x="44" y="38">董事会办公室</tspan>
                    </text>
                  </g>
                  <rect
                    id="矩形"
                    fill="url(#linearGradient-1)"
                    x="441"
                    y="0"
                    width="300"
                    height="100"
                    rx="4"
                  ></rect>
                  <g id="矩形备份">
                    <use
                      fill="black"
                      fill-opacity="1"
                      filter="url(#filter-4)"
                      xlink:href="#path-3"
                    ></use>
                    <use
                      fill="url(#linearGradient-2)"
                      fill-rule="evenodd"
                      xlink:href="#path-3"
                    ></use>
                  </g>
                  <text
                    id="中产集团"
                    font-family="PingFangSC-Semibold, PingFang SC"
                    font-size="30"
                    font-weight="500"
                    fill="#FFFFFF"
                  >
                    <tspan x="531" y="61">中产集团</tspan>
                  </text>
                  <text
                    id="董事会"
                    font-family="PingFangSC-Semibold, PingFang SC"
                    font-size="24"
                    font-weight="500"
                    fill="#FFFFFF"
                  >
                    <tspan x="555" y="193">董事会</tspan>
                  </text>
                  <g
                    id="编组-7备份-8"
                    transform="translate(1120.227053, 319.000000)"
                  >
                    <rect
                      id="矩形备份-3"
                      stroke="#15659E"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="179"
                      rx="4"
                    ></rect>
                    <text
                      id="研发中心"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="21" y="55">研</tspan>
                      <tspan x="21" y="83">发</tspan>
                      <tspan x="21" y="111">中</tspan>
                      <tspan x="21" y="139">心</tspan>
                    </text>
                  </g>
                  <g
                    id="编组-7备份-7"
                    transform="translate(980.227053, 319.000000)"
                  >
                    <rect
                      id="矩形备份-3"
                      stroke="#15659E"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="179"
                      rx="4"
                    ></rect>
                    <text
                      id="上海浦东科苑培训中心"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="10.5" y="41">上海</tspan>
                      <tspan x="10.5" y="69">浦东</tspan>
                      <tspan x="10.5" y="97">科苑</tspan>
                      <tspan x="10.5" y="125">培训</tspan>
                      <tspan x="10.5" y="153">中心</tspan>
                    </text>
                  </g>
                  <g
                    id="编组-7备份-6"
                    transform="translate(840.227053, 319.000000)"
                  >
                    <rect
                      id="矩形备份-3"
                      stroke="#15659E"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="179"
                      rx="4"
                    ></rect>
                    <text
                      id="中产资本"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="21" y="55">中</tspan>
                      <tspan x="21" y="83">产</tspan>
                      <tspan x="21" y="111">资</tspan>
                      <tspan x="21" y="139">本</tspan>
                    </text>
                  </g>
                  <g
                    id="编组-7备份-5"
                    transform="translate(700.227053, 319.000000)"
                  >
                    <rect
                      id="矩形备份-3"
                      stroke="#15659E"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="179"
                      rx="4"
                    ></rect>
                    <text
                      id="上海星动力"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="21" y="41">上</tspan>
                      <tspan x="21" y="69">海</tspan>
                      <tspan x="21" y="97">星</tspan>
                      <tspan x="21" y="125">动</tspan>
                      <tspan x="21" y="153">力</tspan>
                    </text>
                  </g>
                  <g
                    id="编组-7备份-4"
                    transform="translate(560.227053, 320.000000)"
                  >
                    <rect
                      id="矩形备份-3"
                      stroke="#15659E"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="179"
                      rx="4"
                    ></rect>
                    <text
                      id="政府招商事业部"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="10" y="55">政府</tspan>
                      <tspan x="10" y="83">招商</tspan>
                      <tspan x="10" y="111">事业</tspan>
                      <tspan x="20" y="139">部</tspan>
                    </text>
                  </g>
                  <g
                    id="编组-7备份-3"
                    transform="translate(420.227053, 319.000000)"
                  >
                    <rect
                      id="矩形备份-3"
                      stroke="#15659E"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="179"
                      rx="4"
                    ></rect>
                    <text
                      id="媒体信息部"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="21" y="41">媒</tspan>
                      <tspan x="21" y="69">体</tspan>
                      <tspan x="21" y="97">信</tspan>
                      <tspan x="21" y="125">息</tspan>
                      <tspan x="21" y="153">部</tspan>
                    </text>
                  </g>
                  <g
                    id="编组-7备份-2"
                    transform="translate(280.227053, 319.000000)"
                  >
                    <rect
                      id="矩形备份-3"
                      stroke="#15659E"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="179"
                      rx="4"
                    ></rect>
                    <text
                      id="财务部"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="21" y="69">财</tspan>
                      <tspan x="21" y="97">务</tspan>
                      <tspan x="21" y="125">部</tspan>
                    </text>
                  </g>
                  <g
                    id="编组-7备份"
                    transform="translate(140.227053, 319.000000)"
                  >
                    <rect
                      id="矩形备份-3"
                      stroke="#15659E"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="179"
                      rx="4"
                    ></rect>
                    <text
                      id="行政部"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="21" y="69">行</tspan>
                      <tspan x="21" y="97">政</tspan>
                      <tspan x="21" y="125">部</tspan>
                    </text>
                  </g>
                  <g id="编组-7" transform="translate(0.000000, 319.000000)">
                    <rect
                      id="矩形备份-3"
                      stroke="#15659E"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="179"
                      rx="4"
                    ></rect>
                    <text
                      id="人事部"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="21" y="69">人</tspan>
                      <tspan x="21" y="97">事</tspan>
                      <tspan x="21" y="125">部</tspan>
                    </text>
                  </g>
                  <g
                    id="编组-9备份-5"
                    transform="translate(906.227053, 581.000000)"
                  >
                    <rect
                      id="矩形备份-4"
                      stroke="#0C64A0"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="175"
                      rx="4"
                    ></rect>
                    <text
                      id="行政部"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="20" y="67">行</tspan>
                      <tspan x="20" y="95">政</tspan>
                      <tspan x="20" y="123">部</tspan>
                    </text>
                  </g>
                  <g
                    id="编组-9备份-4"
                    transform="translate(763.227053, 577.000000)"
                  >
                    <rect
                      id="矩形备份-4"
                      stroke="#0C64A0"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="175"
                      rx="4"
                    ></rect>
                    <text
                      id="人事部"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="20" y="67">人</tspan>
                      <tspan x="20" y="95">事</tspan>
                      <tspan x="20" y="123">部</tspan>
                    </text>
                  </g>
                  <g
                    id="编组-9备份-3"
                    transform="translate(626.227053, 581.000000)"
                  >
                    <rect
                      id="矩形备份-4"
                      stroke="#0C64A0"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="175"
                      rx="4"
                    ></rect>
                    <text
                      id="业务支持部"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="20" y="39">业</tspan>
                      <tspan x="20" y="67">务</tspan>
                      <tspan x="20" y="95">支</tspan>
                      <tspan x="20" y="123">持</tspan>
                      <tspan x="20" y="151">部</tspan>
                    </text>
                  </g>
                  <g
                    id="编组-9备份-2"
                    transform="translate(486.227053, 581.000000)"
                  >
                    <rect
                      id="矩形备份-4"
                      stroke="#0C64A0"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="175"
                      rx="4"
                    ></rect>
                    <text
                      id="促进落地部"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="20" y="39">促</tspan>
                      <tspan x="20" y="67">进</tspan>
                      <tspan x="20" y="95">落</tspan>
                      <tspan x="20" y="123">地</tspan>
                      <tspan x="20" y="151">部</tspan>
                    </text>
                  </g>
                  <g
                    id="编组-9备份"
                    transform="translate(346.227053, 581.000000)"
                  >
                    <rect
                      id="矩形备份-4"
                      stroke="#0C64A0"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="175"
                      rx="4"
                    ></rect>
                    <text
                      id="项目部"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="20" y="67">项</tspan>
                      <tspan x="20" y="95">目</tspan>
                      <tspan x="20" y="123">部</tspan>
                    </text>
                  </g>
                  <g id="编组-9" transform="translate(206.227053, 581.000000)">
                    <rect
                      id="矩形备份-4"
                      stroke="#15659E"
                      fill="#E2F3FF"
                      x="0.5"
                      y="0.5"
                      width="59"
                      height="175"
                      rx="4"
                    ></rect>
                    <text
                      id="招商部"
                      font-family="PingFangSC-Semibold, PingFang SC"
                      font-size="20"
                      font-weight="500"
                      fill="#15659E"
                    >
                      <tspan x="20" y="67">招</tspan>
                      <tspan x="20" y="95">商</tspan>
                      <tspan x="20" y="123">部</tspan>
                    </text>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div id="develop" class="aboutus-develop">
      <p class="aboutus-title" style="padding:60px 0;color: #fff;">发展历程</p>
      <div class="aboutus-step container">
        <ul class="flex-row">
          <li
            v-for="v in years"
            :key="v"
            :class="{ active: v == currentYear }"
            @click="currentYear = v"
          >
            {{ v }}
          </li>
        </ul>
        <div class="line"></div>
        <div class="carousel">
          <img
            @click="prev('carouselCase')"
            style="left:-4%;top:136px;position:absolute;cursor: pointer;"
            src="@/assets/images/aboutUs/left-arrow.png"
            alt=""
          />
          <img
            @click="next('carouselCase')"
            style="right:-4%;top:136px;position:absolute;cursor: pointer;"
            src="@/assets/images/aboutUs/right-arrow.png"
            alt=""
          />
          <el-carousel
            indicator-position="outside"
            :autoplay="false"
            ref="carouselCase"
            arrow="never"
            height="370px"
            :initial-index="carouselIndex"
            @change="change"
          >
            <el-carousel-item v-for="(v, i) in developList" :key="i">
              <div
                class="flex-row carousel-container animate__animated animate__fadeIn"
              >
                <div
                  class="carousel-item flex-col"
                  v-for="(j, index) in v"
                  :key="index"
                >
                  <p class="title">{{ j.historicTime }}</p>
                  <img :src="j.picture" alt="" v-if="j.picture" />
                  <p class="desc">{{ j.content }}</p>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div id="evaluate" class="aboutus-evaluate">
      <p class="aboutus-title" style="padding:60px 0 55px;">各界评价</p>
      <div class="container" style="position:relative">
        <img
          v-if="movieList[1]"
          @click="prev('carousel')"
          style="left:-90px;top:200px;position:absolute;cursor: pointer;"
          src="@/assets/images/aboutUs/left-arrow.png"
          alt=""
        />
        <img
          v-if="movieList[1]"
          @click="next('carousel')"
          style="right:-90px;top:200px;position:absolute;cursor: pointer;"
          src="@/assets/images/aboutUs/right-arrow.png"
          alt=""
        />
        <el-carousel
          ref="carousel"
          arrow="never"
          height="530px"
          :autoplay="false"
          indicator-position="outside"
        >
          <el-carousel-item v-for="(i, index) in movieList" :key="index">
            <div class="flex-row movie-list">
              <div v-for="(j, jdx) in i" :key="jdx">
                <video
                  controls
                  disablePictureInPicture="true"
                  controlslist="nodownload noremoteplayback noplaybackrate"
                  :src="j.movie"
                ></video>
                <p>{{ j.word }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- <div id="cooperation" class="aboutus-cooperation">
      <p class="aboutus-title" style="padding:60px 0 55px;">合作伙伴</p>
      <div class="container flex-row aboutus-cooperation-list">
        <div
          v-for="(i, index) in cooperationList"
          :key="index"
          class="aboutus-cooperation-item flex-row"
        >
          <img :src="i" alt="" />
        </div>
      </div>
    </div> -->
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/css/aboutus.css";
import Header from "./Header";
import Footer from "./Footer";
export default {
  name: "AboutUs",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      movieList: [
        [
          {
            movie:
              "https://bigscreenvideo.oss-cn-shanghai.aliyuncs.com/website/video/上市启动仪式_冠科美博制药公司创始人及董事长、美国华人生物医药科技协会创始会长、美国浙江商会会长_余国良.mp4",
            word:
              "冠科美博制药公司创始人及董事长、美国华人生物医药科技协会创始会长、美国浙江商会会长_余国良"
          },
          {
            movie:
              "https://bigscreenvideo.oss-cn-shanghai.aliyuncs.com/website/video/上市启动仪式_前TCL副董事长、山东晶泰星光电科技有限公司董事长_袁信成.mp4",
            word: "前TCL副董事长、山东晶泰星光电科技有限公司董事长_袁信成"
          },
          {
            movie:
              "https://bigscreenvideo.oss-cn-shanghai.aliyuncs.com/website/video/上市启动仪式_容百科技董事长_白厚善.mp4",
            word: "容百科技董事长_白厚善"
          },
          {
            movie:
              "https://bigscreenvideo.oss-cn-shanghai.aliyuncs.com/website/video/上市启动仪式_中国科学院院士、西湖大学校长_施一公.mp4",
            word: "中国科学院院士、西湖大学校长_施一公"
          },
          {
            movie:
              "https://bigscreenvideo.oss-cn-shanghai.aliyuncs.com/website/video/政府评价_武乡县经济技术服务中心主任_李晓东.mp4",
            word: "武乡县经济技术服务中心主任_李晓东"
          },
          {
            movie:
              "https://bigscreenvideo.oss-cn-shanghai.aliyuncs.com/website/video/政府评价_招商部部长、常州天宁经济开发区_乔婷婷.mp4",
            word: "招商部部长、常州天宁经济开发区_乔婷婷"
          }
        ]
        // [
        //   { movie: "https://bigscreenvideo.oss-cn-shanghai.aliyuncs.com/website/video/政府评价_招商部部长、常州天宁经济开发区_乔婷婷.mp4", word: "招商部部长、常州天宁经济开发区_乔婷婷" },
        // ]
      ],
      cooperationList: [
        require("@/assets/images/aboutUs/cooperation01.png"),
        require("@/assets/images/aboutUs/cooperation02.png"),
        require("@/assets/images/aboutUs/cooperation03.png"),
        require("@/assets/images/aboutUs/cooperation04.png"),
        require("@/assets/images/aboutUs/cooperation05.png"),
        require("@/assets/images/aboutUs/cooperation06.png"),
        require("@/assets/images/aboutUs/cooperation07.png"),
        require("@/assets/images/aboutUs/cooperation08.png"),
        require("@/assets/images/aboutUs/cooperation09.png"),
        require("@/assets/images/aboutUs/cooperation10.png"),
        require("@/assets/images/aboutUs/cooperation11.png"),
        require("@/assets/images/aboutUs/cooperation12.png"),
        require("@/assets/images/aboutUs/cooperation13.png"),
        require("@/assets/images/aboutUs/cooperation14.png"),
        require("@/assets/images/aboutUs/cooperation15.png"),
        require("@/assets/images/aboutUs/cooperation16.png"),
        require("@/assets/images/aboutUs/cooperation17.png"),
        require("@/assets/images/aboutUs/cooperation18.png"),
        require("@/assets/images/aboutUs/cooperation19.png"),
        require("@/assets/images/aboutUs/cooperation20.png")
      ],
      years: [2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014],
      currentYear: 2024,
      developList: [],
      list: [
        {
          title: "2022年2月1日",
          img: "",
          desc:
            "新疆维吾尔自治区党委书记马兴瑞新春调研首站视察了中产集团推动落户当地的农业科技项目"
        },
        {
          title: "2022年2月1日",
          img: require("@/assets/images/aboutUs/banner-bg.jpg"),
          desc:
            "中产集团发起成立的“中韩企业家联谊会”获颁上海韩国商会顾问委员单位证书"
        },
        {
          title: "2022年1月18日",
          img: "",
          desc:
            "中国中铁城市开发研究院和中国中铁六局发起的“乡村振兴与共同富裕”主题论坛在中产集团举行"
        },
        {
          title: "2022年2月1日",
          img: "",
          desc:
            "新疆维吾尔自治区党委书记马兴瑞新春调研首站视察了中产集团推动落户当地的农业科技项目"
        },
        {
          title: "2022年2月1日",
          img: require("@/assets/images/aboutUs/banner-bg.jpg"),
          desc:
            "中产集团发起成立的“中韩企业家联谊会”获颁上海韩国商会顾问委员单位证书"
        },
        {
          title: "2022年1月18日",
          img: "",
          desc:
            "中国中铁城市开发研究院和中国中铁六局发起的“乡村振兴与共同富裕”主题论坛在中产集团举行"
        },
        {
          title: "2022年2月1日",
          img: "",
          desc:
            "新疆维吾尔自治区党委书记马兴瑞新春调研首站视察了中产集团推动落户当地的农业科技项目"
        },
        {
          title: "2022年2月1日",
          img: require("@/assets/images/aboutUs/banner-bg.jpg"),
          desc:
            "中产集团发起成立的“中韩企业家联谊会”获颁上海韩国商会顾问委员单位证书"
        }
        // {
        //   title: "2022年1月18日",
        //   img: "",
        //   desc: "中国中铁城市开发研究院和中国中铁六局发起的“乡村振兴与共同富裕”主题论坛在中产集团举行"
        // }
      ],
      carouselIndex: 0,
      direction: ""
    };
  },

  created() {
    this.handleData();
  },

  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 200,
      mobile: false,
      live: true
    });
    wow.init();
  },
  methods: {
    // 切换年份
    change(val) {
      if (val == this.carouselIndex) {
        switch (this.direction) {
          case "prev":
            this.currentYear += 1;
            break;
          case "next":
            this.currentYear -= 1;
            break;
          default:
            break;
        }
      } else {
        this.carouselIndex = val;
      }
    },
    prev(str) {
      this.$refs[str].prev();
      this.direction = "prev";
      setTimeout(() => {
        if (this.currentYear == 2022) {
          return;
        }
        if (this.carouselIndex == 0) {
          //只有一页
          this.currentYear += 1;
        }
      }, 100);
    },
    next(str) {
      this.$refs[str].next();
      this.direction = "next";
      setTimeout(() => {
        if (this.currentYear == 2014) {
          return;
        }
        if (this.carouselIndex == 0) {
          //只有一页
          this.currentYear -= 1;
        }
      }, 100);
    },

    // 异步获取数据
    getDevelopList() {
      this.Axios.post(`/api/index/cms/history/list`, {
        year: this.currentYear
      }).then(res => {
        this.handleData(res.data.data);
      });
    },

    // 处理发展历程数据
    handleData(array) {
      // https://www.lodashjs.com/docs/lodash.chunk
      this.developList = this.$lodash.chunk(array, 3);
    }
  },

  watch: {
    currentYear: {
      immediate: true,
      handler(n, o) {
        if (n !== o) {
          this.getDevelopList();
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AboutUs.vue